import { useGetTrConfig, useGetTrScenarios } from "features/technical-data/scenario/api/hooks";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { formatJobConfigRows, resolveScenarioNames } from "../lib/formatJobConfigRows";

export const useTransientJobConfig = (configId?: number) => {
  const { t } = useTranslation();
  const { projectId } = useParams();
  const enabled = Boolean(projectId) && configId != null;
  const configQuery = useGetTrConfig(projectId, configId);
  const scenariosQuery = useGetTrScenarios(enabled ? projectId : undefined);
  const scenarioNames = useMemo(
    () => resolveScenarioNames(configQuery.data?.scenarios ?? [], scenariosQuery.data ?? []),
    [configQuery.data?.scenarios, scenariosQuery.data]
  );
  const rows = useMemo(() => {
    if (!configQuery.data) return [];
    return formatJobConfigRows(configQuery.data, scenarioNames, (key) => t(key));
  }, [configQuery.data, scenarioNames, t]);

  return {
    error: configQuery.isError ? t("Execution.transient.jobDetails.configFailed") : null,
    isLoading: enabled && (configQuery.isLoading || scenariosQuery.isLoading),
    rows,
  };
};
